import React from 'react'
import './section-title-divisor.scss'
export default function SectionTitleDivisor({ children }) {
  return (
    <div className="f-section-title-divisor">
      <div className="line"></div>
      <div className="title">{children}</div>
      <div className="line"></div>
    </div>
  )
}
